<template>
  <div class="personal-information">
    <div class="info-block personal-info">
      <h2 class="title small">{{ $t(`Personal Information`) }}</h2>
      <form @submit.prevent="updatePersonalInfo">
        <div class="input-row">
          <div class="input-group">
            <!--<label for="name">{{ $t(`First name`) }}</label>-->
            <input
              type="text"
              id="name"
              v-model="personalInfo.name"
              :placeholder="$t('First name')"
            />
          </div>
          <div class="input-group">
            <!--<label for="surname">{{ $t(`Last name`) }}</label>-->
            <input
              type="text"
              id="surname"
              v-model="personalInfo.surname"
              :placeholder="$t('Last name')"
            />
          </div>
        </div>
        <div class="input-group">
          <!--<label for="email">{{ $t(`Email`) }}</label>-->
          <input
            type="email"
            id="email"
            v-model="personalInfo.email"
            :placeholder="$t('Email')"
          />
        </div>
        <div class="input-group">
          <!--<label for="phone">{{ $t(`Phone`) }}</label>-->
          <input
            type="tel"
            id="phone"
            v-model="personalInfo.phone"
            :placeholder="$t('Phone')"
          />
        </div>
        <div class="input-group">
          <input
            type="url"
            id="steamProfileUrl"
            v-model="personalInfo.steamProfileUrl"
            :placeholder="$t('Steam URL')"
          />
        </div>

        <div v-if="personalInfoError" class="error-message">
          {{ personalInfoError }}
        </div>
        <div v-if="personalInfoSuccess" class="success-message">
          {{ personalInfoSuccess }}
        </div>

        <button class="red button w-130" type="submit">
          {{ $t("CHANGE") }}
        </button>
      </form>
    </div>

    <div class="info-block billing-info">
      <h2 class="title small">{{ $t(`Billing Information`) }}</h2>
      <form @submit.prevent="updateBillingInfo">
        <div class="input-row">
          <div class="input-group">
            <!--<label for="country">{{ $t(`Country`) }}</label>-->
            <select id="country" v-model="billingInfo.country">
              <option
                v-for="country in countryOptions"
                :key="country.id"
                :value="country.id"
              >
                {{ country.title }}
              </option>
            </select>
          </div>
          <div class="input-group">
            <!--<label for="city">{{ $t(`City`) }}</label>-->
            <input
              type="text"
              id="city"
              v-model="billingInfo.city"
              :placeholder="$t('City')"
            />
          </div>
        </div>
        <div class="input-group">
          <!--<label for="postCode">{{ $t(`ZIP-code`) }}</label>-->
          <input
            type="text"
            id="postCode"
            v-model="billingInfo.postCode"
            :placeholder="$t('ZIP-code')"
          />
        </div>
        <div class="input-group">
          <!--<label for="address">{{ $t(`Address`) }}</label>-->
          <input
            type="text"
            id="address"
            v-model="billingInfo.address"
            :placeholder="$t('Address')"
          />
        </div>

        <div v-if="billingInfoError" class="error-message">
          {{ billingInfoError }}
        </div>
        <div v-if="billingInfoSuccess" class="success-message">
          {{ billingInfoSuccess }}
        </div>

        <div class="button-wrapper">
          <button class="red button w-130" type="submit">
            {{ $t("CHANGE") }}
          </button>
        </div>
      </form>
    </div>
    <ChangePassword />
  </div>
</template>

<script>
import ChangePassword from "../tabs/ChangePassword.vue";
export default {
  name: "PersonalInformation",

  components: {
    ChangePassword,
  },
  data() {
    return {
      personalInfo: {
        name: "",
        surname: "",
        email: "",
        phone: "",
        steamProfileUrl: "",
      },
      billingInfo: {
        country: "",
        city: "",
        postCode: "",
        address: "",
      },
      countryOptions: [],
      personalInfoError: null,
      billingInfoError: null,
      personalInfoSuccess: null,
      billingInfoSuccess: null,
    };
  },
  methods: {
    updatePersonalInfo() {
      this.personalInfoError = null;
      this.personalInfoSuccess = null;

      this.$http
        .put(process.env.VUE_APP_API + "user/profile", {
          name: this.personalInfo.name,
          surname: this.personalInfo.surname,
          email: this.personalInfo.email,
          phone: this.personalInfo.phone,
          ...this.billingInfo,
        })
        .then(async (response) => {
          if (response.data?.status === "OK") {
            await this.updateSteamProfileUrl();
            this.personalInfoSuccess = "Successfully updated!";
            this.personalInfoError = "";

            setTimeout(() => {
              this.personalInfoSuccess = "";
            }, 2000);
            // this.$toast.success("Personal information updated successfully!");
          } else {
            this.personalInfoSuccess = "";
            this.personalInfoError =
              this.$t(response.data.message) || "An unexpected error occurred.";
            setTimeout(() => {
              this.personalInfoError = "";
            }, 2000);
          }
        })
        .catch((error) => {
          this.personalInfoError =
            this.$t(error.response.data.message) ||
            "Error updating personal information.";
          setTimeout(() => {
            this.personalInfoError = "";
          }, 2000);
          console.error("Error updating personal information:", error);
        });
    },
    updateBillingInfo() {
      this.billingInfoError = null;
      this.billingInfoSuccess = null;

      this.$http
        .put(process.env.VUE_APP_API + "user/profile", {
          name: this.personalInfo.name,
          surname: this.personalInfo.surname,
          email: this.personalInfo.email,
          phone: this.personalInfo.phone,
          ...this.billingInfo,
        })
        .then((response) => {
          if (response.data?.status === "OK") {
            this.billingInfoError = "";
            this.billingInfoSuccess = "Successfully updated!";
            // this.$toast.success("Billing information updated successfully!");
            setTimeout(() => {
              this.billingInfoSuccess = "";
            }, 2000);
          } else {
            this.billingInfoSuccess = "";
            this.billingInfoError =
              this.$t(response.data.message) || "An unexpected error occurred.";
            setTimeout(() => {
              this.billingInfoError = "";
            }, 2000);
          }
        })
        .catch((error) => {
          this.billingInfoSuccess = "";
          this.billingInfoError =
            this.$t(error.response.data.message) ||
            this.$t("Error updating billing information.");
          setTimeout(() => {
            this.billingInfoError = "";
          }, 2000);
          console.error("Error updating billing information:", error);
        });
    },
    async fetchCountryOptions() {
      try {
        const response = await this.$http.get(
          process.env.VUE_APP_API + "countries",
        );
        this.countryOptions = response.data.payload;
      } catch (error) {
        console.error("Error fetching country options:", error);
      }
    },
    async fetchUserData() {
      try {
        const response = await this.$http.get(
          process.env.VUE_APP_API + "user/profile",
        );
        this.personalInfo = {
          name: response.data.name,
          surname: response.data.surname,
          email: response.data.email,
          phone: response.data.phone,
          steamProfileUrl: response.data.steam_profile_url || "",
        };
        this.billingInfo = {
          country: response.data.country,
          city: response.data.city,
          postCode: response.data.zip,
          address: response.data.address,
        };
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },
    async updateSteamProfileUrl() {
      if (!this.personalInfo.steamProfileUrl) {
        return;
      }

      await this.$http.put(process.env.VUE_APP_API + "user/steam-profile-url", {
        url: this.personalInfo.steamProfileUrl,
      });
    },
  },
  created() {
    this.fetchUserData();
    this.fetchCountryOptions();
  },
};
</script>

<style scoped>
.personal-information {
  background: #191919;
  margin-top: 16px;
  border-radius: 12px;
}

.info-block {
  padding: 32px;
  flex: 1;

  .button {
    margin-top: 28px;
  }
}

h2 {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 120%;
  color: white;
  margin-bottom: 46px;
}

.input-row {
  display: flex;
  gap: 14px;
  max-width: 366px;
}

.input-group {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: 14px;
  max-width: 366px;
}

label {
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  color: #b7b8c1;
  margin-bottom: 8px;
}

.error-message {
  color: red;
  font-weight: bold;
  margin-bottom: 10px;
}

.success-message {
  color: green;
  font-weight: bold;
  margin-bottom: 10px;
}

@media (max-width: 768px) {
  .personal-information {
    flex-direction: column;
    gap: 20px;
    margin-top: 20px;
    padding: 12px;
  }

  .info-block {
    width: 100%;
    padding: 20px;
    border-radius: 2px;
  }

  .input-row {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
  }

  .input-group {
    margin-bottom: 10px;
  }

  h2 {
    font-size: 14px;
    margin-bottom: 20px;
  }

  .update-profile-button {
    width: 100%;
    box-sizing: border-box;
  }

  .modal-button-wrapper {
    width: 100%;
    max-width: 100%;
    text-align: left;
    margin: 0;
  }
}
</style>
